import MainPageRelatorios from '@/screens/relatorios/MainPage.vue'
import { items } from '@/screens/relatorios/config.js'

const relatorios = [
  {
    path: '/relatorios',
    name: 'relatorios',
    component: MainPageRelatorios,
    children: [...items]
  }
]

export default relatorios



// WEBPACK FOOTER //
// ./src/router/relatorios.js